{
  "version": 1,
  "asset_id": "6f8de80c-3028-48ac-bad2-4f9562076f6d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6f8de80c-3028-48ac-bad2-4f9562076f6d/dilated-pouch-boxed-en-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6f8de80c-3028-48ac-bad2-4f9562076f6d/dilated-pouch-boxed-en-480.jpg",
  "original_filename": "dilated-pouch-boxed-en-480.jpg",
  "size": 31503,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:27:39Z"
}
